(function () {
  if (window.AncoraGiftBoxCartLoaded) return;
  window.AncoraGiftBoxCartLoaded = true;

  function getRootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function endpoint(path) {
    var root = getRootUrl();

    if (!root.endsWith('/')) {
      root += '/';
    }

    return root + path.replace(/^\//, '');
  }

  function getGiftBoxBlock(element) {
    return element.closest('[data-gift-box]');
  }

  function getGiftBoxModal(element) {
    var block = getGiftBoxBlock(element);
    return block ? block.querySelector('[data-gift-box-modal]') : null;
  }

  function isPhotoEnabled(block) {
    return block && block.getAttribute('data-gift-box-photo-enabled') === 'true';
  }

  function isPhotoRequired(block) {
    return block && block.getAttribute('data-gift-box-photo-required') === 'true';
  }

  function getPhotoPropertyName(block) {
    return block.getAttribute('data-gift-box-photo-property-name') || 'Gift photo';
  }

  function getCurrentPhoto(block) {
    return block.getAttribute('data-gift-box-current-photo') || '';
  }

  function getPhotoMaxBytes(block) {
    var maxBytes = parseInt(block.getAttribute('data-gift-box-photo-max-bytes'), 10);

    if (!maxBytes || isNaN(maxBytes)) {
      maxBytes = 5 * 1024 * 1024;
    }

    return maxBytes;
  }

  function getSelectedPhoto(block) {
    var input = block.querySelector('[data-gift-box-photo]');

    if (!input || !input.files || !input.files.length) {
      return null;
    }

    return input.files[0];
  }

  function setPhotoError(block, message) {
    var error = block.querySelector('[data-gift-box-photo-error]');

    if (error) {
      error.textContent = message || '';
    }
  }

  function clearPhotoSelection(block) {
    var input = block.querySelector('[data-gift-box-photo]');
    var preview = block.querySelector('[data-gift-box-photo-preview]');
    var previewImage = preview ? preview.querySelector('img') : null;

    if (input) {
      input.value = '';
    }

    if (preview) {
      if (preview.dataset.previewUrl) {
        URL.revokeObjectURL(preview.dataset.previewUrl);
        delete preview.dataset.previewUrl;
      }

      preview.hidden = true;
    }

    if (previewImage) {
      previewImage.removeAttribute('src');
      previewImage.setAttribute('alt', '');
    }

    setPhotoError(block, '');
  }

  function updatePhotoPreview(block) {
    var file = getSelectedPhoto(block);
    var preview = block.querySelector('[data-gift-box-photo-preview]');
    var previewImage = preview ? preview.querySelector('img') : null;

    if (!preview || !previewImage) return;

    if (preview.dataset.previewUrl) {
      URL.revokeObjectURL(preview.dataset.previewUrl);
      delete preview.dataset.previewUrl;
    }

    if (!file) {
      preview.hidden = true;
      previewImage.removeAttribute('src');
      previewImage.setAttribute('alt', '');
      return;
    }

    var previewUrl = URL.createObjectURL(file);
    preview.dataset.previewUrl = previewUrl;
    previewImage.src = previewUrl;
    previewImage.alt = file.name || 'Gift photo preview';
    preview.hidden = false;
  }

  function isAcceptedPhoto(file, input) {
    if (!file || !input) return true;

    var accept = input.getAttribute('accept');

    if (!accept) return true;

    var fileName = (file.name || '').toLowerCase();
    var fileType = (file.type || '').toLowerCase();
    var accepted = accept.split(',').map(function (item) {
      return item.trim().toLowerCase();
    }).filter(Boolean);

    if (!accepted.length) return true;

    return accepted.some(function (rule) {
      if (rule.charAt(0) === '.') {
        return fileName.endsWith(rule);
      }

      if (rule.endsWith('/*')) {
        return fileType.indexOf(rule.replace('/*', '/')) === 0;
      }

      return fileType === rule;
    });
  }

  function validateGiftPhoto(block) {
    if (!isPhotoEnabled(block)) {
      return {
        valid: true,
        file: null
      };
    }

    var input = block.querySelector('[data-gift-box-photo]');
    var file = getSelectedPhoto(block);
    var currentPhoto = getCurrentPhoto(block);
    var maxBytes = getPhotoMaxBytes(block);
    var maxMb = Math.round(maxBytes / 1024 / 1024);

    setPhotoError(block, '');

    if (isPhotoRequired(block) && !file && !currentPhoto) {
      setPhotoError(block, 'Please upload a gift photo.');
      return {
        valid: false,
        file: null
      };
    }

    if (!file) {
      return {
        valid: true,
        file: null
      };
    }

    if (file.size > maxBytes) {
      setPhotoError(block, 'The photo is too large. Max size is ' + maxMb + 'MB.');
      return {
        valid: false,
        file: null
      };
    }

    if (!isAcceptedPhoto(file, input)) {
      setPhotoError(block, 'Please upload a valid image file.');
      return {
        valid: false,
        file: null
      };
    }

    return {
      valid: true,
      file: file
    };
  }

  function openModal(block) {
    var modal = block.querySelector('[data-gift-box-modal]');
    var textarea = block.querySelector('[data-gift-box-message]');
    var currentMessage = block.getAttribute('data-gift-box-current-message') || '';

    if (!modal) return;

    clearPhotoSelection(block);

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gift-box-modal-open');

    if (textarea) {
      textarea.value = currentMessage;
      updateCounter(block);

      setTimeout(function () {
        textarea.focus();
      }, 120);
    }
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gift-box-modal-open');
  }

  function updateCounter(block) {
    var textarea = block.querySelector('[data-gift-box-message]');
    var counter = block.querySelector('[data-gift-box-count]');

    if (!textarea || !counter) return;

    counter.textContent = textarea.value.length;
  }

  function setError(block, message) {
    var error = block.querySelector('[data-gift-box-error]');

    if (error) {
      error.textContent = message || '';
    }
  }

  function setLoading(block, isLoading) {
    if (!block) return;

    block.classList.toggle('is-loading', isLoading);

    var buttons = block.querySelectorAll('button');
    buttons.forEach(function (button) {
      button.disabled = isLoading;
    });
  }

  function getCart() {
    return fetch(endpoint('/cart.js'), {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not get cart');
      }

      return response.json();
    });
  }

  function findGiftLines(cart, variantId) {
    var lines = [];

    cart.items.forEach(function (item, index) {
      if (Number(item.variant_id) === Number(variantId)) {
        lines.push({
          line: index + 1,
          item: item
        });
      }
    });

    return lines;
  }

  function buildGiftProperties(block, message, includeCurrentPhoto) {
    var properties = {
      '_gift_box': 'true',
      'Gift message': message
    };

    if (includeCurrentPhoto && isPhotoEnabled(block)) {
      var currentPhoto = getCurrentPhoto(block);

      if (currentPhoto) {
        properties[getPhotoPropertyName(block)] = currentPhoto;
      }
    }

    return properties;
  }

  function changeLine(line, quantity, properties) {
    var body = {
      line: line,
      quantity: quantity
    };

    if (properties) {
      body.properties = properties;
    }

    return fetch(endpoint('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not change cart line');
      }

      return response.json();
    });
  }

  function addGiftBoxJson(block, variantId, message) {
    return fetch(endpoint('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: buildGiftProperties(block, message, false)
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not add gift box');
      }

      return response.json();
    });
  }

  function addGiftBoxWithPhoto(block, variantId, message, file) {
    var formData = new FormData();

    formData.append('id', String(variantId));
    formData.append('quantity', '1');
    formData.append('properties[_gift_box]', 'true');
    formData.append('properties[Gift message]', message);

    if (file) {
      formData.append('properties[' + getPhotoPropertyName(block) + ']', file, file.name);
    }

    return fetch(endpoint('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Could not add gift box with photo');
      }

      return response.json();
    });
  }

  function addGiftBox(block, variantId, message, file) {
    if (file) {
      return addGiftBoxWithPhoto(block, variantId, message, file);
    }

    return addGiftBoxJson(block, variantId, message);
  }

  function removeGiftLines(lines) {
    if (!lines.length) {
      return Promise.resolve();
    }

    var reversedLines = lines.map(function (entry) {
      return entry.line;
    }).sort(function (a, b) {
      return b - a;
    });

    var chain = Promise.resolve();

    reversedLines.forEach(function (line) {
      chain = chain.then(function () {
        return changeLine(line, 0);
      });
    });

    return chain;
  }

  function saveGiftBox(block, message, file) {
    var variantId = block.getAttribute('data-gift-box-variant-id');

    return getCart().then(function (cart) {
      var lines = findGiftLines(cart, variantId);

      if (file) {
        return removeGiftLines(lines).then(function () {
          return addGiftBox(block, variantId, message, file);
        });
      }

      if (lines.length === 1) {
        return changeLine(lines[0].line, 1, buildGiftProperties(block, message, true));
      }

      if (lines.length > 1) {
        return removeGiftLines(lines).then(function () {
          return addGiftBox(block, variantId, message, null);
        });
      }

      return addGiftBox(block, variantId, message, null);
    });
  }

  function removeGiftBox(block) {
    var variantId = block.getAttribute('data-gift-box-variant-id');

    return getCart().then(function (cart) {
      var lines = findGiftLines(cart, variantId);

      if (!lines.length) return cart;

      return removeGiftLines(lines);
    });
  }

  function dispatchCartEvents(cart) {
    var events = [
      'cart:build',
      'cart:refresh',
      'cart:updated',
      'ajaxProduct:added'
    ];

    events.forEach(function (eventName) {
      try {
        document.dispatchEvent(new CustomEvent(eventName, {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
      } catch (error) {}
    });
  }

  function replaceElementContent(oldRoot, newRoot, selector) {
    if (!oldRoot || !newRoot) return;

    var oldElement = oldRoot.querySelector(selector);
    var newElement = newRoot.querySelector(selector);

    if (oldElement && newElement) {
      oldElement.innerHTML = newElement.innerHTML;
    }
  }

  function replaceElement(oldRoot, newRoot, selector) {
    if (!oldRoot || !newRoot) return;

    var oldElement = oldRoot.querySelector(selector);
    var newElement = newRoot.querySelector(selector);

    if (oldElement && newElement) {
      oldElement.replaceWith(newElement);
    }
  }

  function refreshGiftBoxSections() {
    return fetch(endpoint('/?sections=cart-drawer,main-cart'), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Could not refresh cart sections');
        }

        return response.json();
      })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var drawerDoc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = drawerDoc.querySelector('#CartDrawer');
          var oldDrawer = document.querySelector('#CartDrawer');

          replaceElement(oldDrawer, newDrawer, '[data-gift-box-location="drawer"]');
          replaceElementContent(oldDrawer, newDrawer, '[data-subtotal]');
          replaceElementContent(oldDrawer, newDrawer, '[data-discounts]');
        }

        if (sections['main-cart']) {
          var cartDoc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
          var newCartForm = cartDoc.querySelector('#CartPageForm');
          var oldCartForm = document.querySelector('#CartPageForm');

          replaceElement(oldCartForm, newCartForm, '[data-gift-box-location="page"]');
          replaceElementContent(oldCartForm, newCartForm, '[data-subtotal]');
          replaceElementContent(oldCartForm, newCartForm, '[data-discounts]');

          var oldProducts = oldCartForm ? oldCartForm.querySelector('[data-products]') : null;
          var newProducts = newCartForm ? newCartForm.querySelector('[data-products]') : null;

          if (oldProducts && newProducts) {
            oldProducts.innerHTML = newProducts.innerHTML;
          }
        }
      });
  }

  function refreshCartAfterGiftBoxChange() {
    return getCart()
      .then(function (cart) {
        dispatchCartEvents(cart);

        return refreshGiftBoxSections()
          .then(function () {
            dispatchCartEvents(cart);
            return cart;
          })
          .catch(function () {
            dispatchCartEvents(cart);
            return cart;
          });
      });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-gift-box-open]');
    var closeButton = event.target.closest('[data-gift-box-close]');
    var submitButton = event.target.closest('[data-gift-box-submit]');
    var removeButton = event.target.closest('[data-gift-box-remove]');
    var clearPhotoButton = event.target.closest('[data-gift-box-photo-clear]');

    if (openButton) {
      event.preventDefault();

      var blockToOpen = getGiftBoxBlock(openButton);

      if (blockToOpen) {
        openModal(blockToOpen);
      }
    }

    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('[data-gift-box-modal]'));
    }

    if (clearPhotoButton) {
      event.preventDefault();

      var blockToClear = getGiftBoxBlock(clearPhotoButton);

      if (blockToClear) {
        clearPhotoSelection(blockToClear);
      }
    }

    if (submitButton) {
      event.preventDefault();

      var blockToSubmit = getGiftBoxBlock(submitButton);
      var modal = getGiftBoxModal(submitButton);
      var textarea = blockToSubmit ? blockToSubmit.querySelector('[data-gift-box-message]') : null;
      var message = textarea ? textarea.value.trim() : '';
      var isRequired = blockToSubmit && blockToSubmit.getAttribute('data-gift-box-required') === 'true';

      if (!blockToSubmit) return;

      setError(blockToSubmit, '');
      setPhotoError(blockToSubmit, '');

      if (isRequired && !message) {
        setError(blockToSubmit, 'Please write a gift message.');
        return;
      }

      var photoValidation = validateGiftPhoto(blockToSubmit);

      if (!photoValidation.valid) {
        return;
      }

      setLoading(blockToSubmit, true);

      saveGiftBox(blockToSubmit, message, photoValidation.file)
        .then(function () {
          closeModal(modal);
          return refreshCartAfterGiftBoxChange();
        })
        .then(function () {
          setLoading(blockToSubmit, false);
        })
        .catch(function () {
          setLoading(blockToSubmit, false);
          setError(blockToSubmit, 'Something went wrong. Please try again.');
        });
    }

    if (removeButton) {
      event.preventDefault();

      var blockToRemove = getGiftBoxBlock(removeButton);

      if (!blockToRemove) return;

      setLoading(blockToRemove, true);

      removeGiftBox(blockToRemove)
        .then(function () {
          return refreshCartAfterGiftBoxChange();
        })
        .then(function () {
          setLoading(blockToRemove, false);
        })
        .catch(function () {
          setLoading(blockToRemove, false);
        });
    }
  });

  document.addEventListener('input', function (event) {
    var textarea = event.target.closest('[data-gift-box-message]');

    if (!textarea) return;

    var block = getGiftBoxBlock(textarea);

    if (block) {
      updateCounter(block);
      setError(block, '');
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-gift-box-photo]');

    if (!input) return;

    var block = getGiftBoxBlock(input);

    if (block) {
      setPhotoError(block, '');
      updatePhotoPreview(block);
      validateGiftPhoto(block);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var activeModal = document.querySelector('.gift-box-modal.is-active');

    if (activeModal) {
      closeModal(activeModal);
    }
  });
})();
